import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
	CaptureLongStayRateCommand,
	CapturePricingCardCommand,
	CaptureProtectionPricingCardCommand,
	ClientPricing,
	DefaultPricingCards,
	EndLongStayRateCommand,
	EndPricingCardCommand,
	PricingProduct,
	ProtectionLevel,
	ReplaceLongStayRateCommand,
	ReplacePricingCardCommand,
	ReplaceProtectionPricingCardCommand,
} from 'models';

@Injectable({
	providedIn: 'root',
})
export class PricingCardService {
	private readonly baseUrl = 'api/pricingcard';

	constructor(private http: HttpClient) {}

	getProducts(): Observable<PricingProduct[]> {
		return this.http.get<PricingProduct[]>(`${this.baseUrl}/products`);
	}

	getLevels(userId?: string | null): Observable<ProtectionLevel[]> {
		const query = userId ? `?userId=${encodeURIComponent(userId)}` : '';
		return this.http.get<ProtectionLevel[]>(`${this.baseUrl}/levels${query}`);
	}

	getDefaults(currencyId?: number | null): Observable<DefaultPricingCards> {
		const query = currencyId ? `?currencyId=${currencyId}` : '';
		return this.http.get<DefaultPricingCards>(`${this.baseUrl}/defaults${query}`);
	}

	getClientPricing(userId: string, currencyId?: number | null): Observable<ClientPricing> {
		const query = currencyId ? `?currencyId=${currencyId}` : '';
		return this.http.get<ClientPricing>(`${this.baseUrl}/client/${encodeURIComponent(userId)}${query}`);
	}

	captureProtectionPricingCard(command: CaptureProtectionPricingCardCommand): Observable<number> {
		return this.http.post<number>(`${this.baseUrl}/protection/capture`, command);
	}

	replaceProtectionPricingCard(command: ReplaceProtectionPricingCardCommand): Observable<number> {
		return this.http.post<number>(`${this.baseUrl}/protection/replace`, command);
	}

	endProtectionPricingCard(command: EndPricingCardCommand): Observable<void> {
		return this.http.post<void>(`${this.baseUrl}/protection/end`, command);
	}

	capturePricingCard(command: CapturePricingCardCommand): Observable<number> {
		return this.http.post<number>(`${this.baseUrl}/card/capture`, command);
	}

	replacePricingCard(command: ReplacePricingCardCommand): Observable<number> {
		return this.http.post<number>(`${this.baseUrl}/card/replace`, command);
	}

	endPricingCard(command: EndPricingCardCommand): Observable<void> {
		return this.http.post<void>(`${this.baseUrl}/card/end`, command);
	}

	captureLongStayRate(command: CaptureLongStayRateCommand): Observable<number> {
		return this.http.post<number>(`${this.baseUrl}/longstay/capture`, command);
	}

	replaceLongStayRate(command: ReplaceLongStayRateCommand): Observable<number> {
		return this.http.post<number>(`${this.baseUrl}/longstay/replace`, command);
	}

	endLongStayRate(command: EndLongStayRateCommand): Observable<void> {
		return this.http.post<void>(`${this.baseUrl}/longstay/end`, command);
	}
}
